import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Discount2 = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M0,26.375,23.527,1.827l13.225,1.6c.019-.019.036-.039.054-.059A11.137,11.137,0,0,1,41.854.222a4.879,4.879,0,0,1,4.9,1.068c2.679,2.8.824,8.472-3.649,11.854l1.145,10.308L20.726,48Zm3.98,0L20.726,43.847,41.3,22.379,39.711,8.059,38.282,6.566,37.9,6.52a8.214,8.214,0,0,0-1.374,2.825,2.557,2.557,0,0,0,.284,2.328L38.8,13.749l-1.991,2.077L30.837,9.6l1.99-2.076.987,1.031a10.309,10.309,0,0,1,.955-2.408L24.556,4.908Zm38.556-23.3A7.368,7.368,0,0,0,40.091,4.3l2.3,2.4.328,2.952c2.133-2.191,3.087-5.2,2.046-6.29a1.682,1.682,0,0,0-1.247-.434A3.939,3.939,0,0,0,42.536,3.071ZM18.2,33.6a4.533,4.533,0,0,1-3.155-1.553,4.507,4.507,0,0,1-1.538-3.132,4.407,4.407,0,0,1,1.509-3.123,4.386,4.386,0,0,1,3.11-1.509,4.559,4.559,0,0,1,3.136,1.564,4.554,4.554,0,0,1,1.56,3.14,4.391,4.391,0,0,1-1.51,3.119A4.39,4.39,0,0,1,18.217,33.6Zm-1.827-6.45q-1.3,1.3.5,3.09,1.775,1.777,3.064.489a1.593,1.593,0,0,0,.54-1.4,3.239,3.239,0,0,0-1.028-1.661,3.265,3.265,0,0,0-1.677-1.034,1.521,1.521,0,0,0-.233-.018A1.626,1.626,0,0,0,16.373,27.152Zm2.987-5.508,3.772-3.773L24.46,19.2l-2.075,2.074,1.169,1.169,1.913-1.913,1.327,1.328L24.882,23.77l2.3,2.3-1.7,1.7Zm4.82-4.82,3.772-3.772L29.28,14.38l-2.074,2.074,1.168,1.168,1.913-1.912,1.328,1.328L29.7,18.95l2.3,2.3-1.7,1.7Z" transform="translate(0 0)" fill={fill} />
    </svg>
  );
};

Discount2.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Discount2.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
